module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-35.feef10d6.svg";